<template>
  <div style="background-color: #f5f5f6">
    <!-- <input @change="onFileChange" type="file" ref="importFile" style="display:none">
    <button @click="$refs.importFile.click()" class="btn btn-success">Import File</button> -->
    <!-- <button @click="check">Check</button> -->
    <!-- <v-col cols="12" style="text-align: right">
      <button class="btn btn-primary btn-sm"><i class="fa fa-plus-square"></i> Add New</button> 	&nbsp;
      <Import :link="link"/>
    </v-col> -->
    <v-col cols="12">
      <v-row>
        <!-- Status for normal users -->
        <!-- <v-col cols="6" style="text-align: left">
          <v-btn
            text
            x-small
            @click="searchStatus('')"
            v-if="roles.read_crawled_product"
          >
            <v-tab>
              <v-badge
                color="info"
                :content="totalCrawlProducts.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == ''" style="color: #7cb342">All</b>
                <b v-else>All</b>
              </v-badge>
            </v-tab>
          </v-btn>
          <v-btn
            text
            x-small
            @click="searchStatus('Pending')"
            v-if="roles.read_crawled_product"
          >
            <v-tab>
              <v-badge
                color="orange darken-2"
                :content="pendingProducts.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Pending'" style="color: #7cb342">Pending</b>
                <b v-else>Pending</b>
              </v-badge>
            </v-tab>
          </v-btn>
          <v-btn text x-small @click="searchStatus('Missing Info')">
            <v-tab>
              <v-badge
                color="deep-orange darken-4"
                :content="missingInfoProducts.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Missing Info'" style="color: #7cb342"
                  >Missing Info</b
                >
                <b v-else>Missing Info</b>
              </v-badge>
            </v-tab>
          </v-btn>
          <v-btn text x-small @click="searchStatus('Ready To Export')">
            <v-tab>
              <v-badge
                color="light-green "
                :content="readyToExportProducts.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Ready To Export'" style="color: #7cb342"
                  >Ready To Export</b
                >
                <b v-else>Ready To Export</b>
              </v-badge>
            </v-tab>
          </v-btn>


        </v-col> -->

        <v-col cols="12" style="text-align: right">
          <template>
            <v-speed-dial
              v-model="fab"
              :direction="direction"
              :open-on-hover="hover"
              :transition="transition"
              style="width: 15px; display: inline"
              v-if="
                dialogUpload == false &&
                dialogTag == false &&
                dialogAssignProductType == false &&
                dialogEditTitleTag == false &&
                dialogConvert == false
              "
            >
              <template v-slot:activator>
                <v-btn small v-model="fab" color="blue darken-2" dark>
                  More Actions
                  <v-icon v-if="fab">mdi-close</v-icon>
                  <v-icon v-else>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <template>
                <v-btn
                  small
                  color="success"
                  @click="addNewProduct"
                  v-if="roles.create_crawled_product"
                  >Add Product<v-icon right dark>mdi-plus-thick</v-icon></v-btn
                >
                <v-btn small color="success" v-else disabled
                  >Add Product<v-icon right dark>mdi-plus-thick</v-icon></v-btn
                >
                <v-btn
                  small
                  color="orange darken-4"
                  class="white--text"
                  @click="changeStatus"
                  v-if="
                    status == 'Pending' &&
                    roles.allow_to_export &&
                    selected.length > 0
                  "
                  >Keep The Product(s) ({{ selected.length }})</v-btn
                >
                <v-btn
                  small
                  color="orange darken-4"
                  class="white--text"
                  v-else
                  disabled
                  >Keep The Product(s) ({{ selected.length }})</v-btn
                >
              </template>
              <template>
                <v-btn
                  small
                  color="pink darken-4"
                  class="white--text"
                  v-if="
                    status == 'Missing Info' &&
                    selected.length > 0 &&
                    roles.allow_to_export
                  "
                  @click="allowDataToExport()"
                  >Allow To Export<v-icon right dark>mdi-tag</v-icon></v-btn
                >
                <v-btn
                  small
                  color="pink darken-4"
                  class="white--text"
                  v-else
                  disabled
                  >Allow To Export<v-icon right dark>mdi-tag</v-icon></v-btn
                >
              </template>

              <template>
                <v-btn
                  small
                  color="deep-purple darken-4"
                  class="white--text"
                  v-if="
                    status != 'Pending' &&
                    status != '' &&
                    selected.length > 0 &&
                    roles.assign_tag
                  "
                  @click="dialogTag = !dialogTag"
                  >Assign Tags<v-icon right dark>mdi-tag</v-icon></v-btn
                >
                <v-btn
                  small
                  color="deep-purple darken-4"
                  class="white--text"
                  v-else
                  disabled
                  >Assign Tags<v-icon right dark>mdi-tag</v-icon></v-btn
                >
              </template>

              <template>
                <v-btn
                  small
                  color="blue darken-1"
                  class="white--text"
                  v-if="
                    status != 'Pending' &&
                    status != '' &&
                    selected.length > 0 &&
                    roles.remove_tag
                  "
                  @click="removeTags"
                  >Remove Tags<v-icon right dark>mdi-tag-remove</v-icon></v-btn
                >
                <v-btn
                  small
                  color="blue darken-1"
                  class="white--text"
                  v-else
                  disabled
                  >Remove Tags<v-icon right dark>mdi-tag-remove</v-icon></v-btn
                >
              </template>

              <template>
                <v-btn
                  small
                  color="orange"
                  class="white--text"
                  @click="dialogAssignProductType = !dialogAssignProductType"
                  v-if="
                    status != '' &&
                    status != 'Ready To Export' &&
                    selected.length > 0 &&
                    roles.assign_product_type
                  "
                  >Assign Product Type ({{ selected.length }})</v-btn
                >
                <v-btn small color="orange" class="white--text" v-else disabled
                  >Assign Product Type ({{ selected.length }})</v-btn
                >
              </template>

              <template>
                <v-btn
                  small
                  color="red"
                  class="white--text"
                  @click="deleteMulti"
                  v-if="
                    status != '' &&
                    selected.length > 0 &&
                    roles.delete_crawled_product
                  "
                  >Delete Items ({{ selected.length }})</v-btn
                >
                <v-btn
                  small
                  color="red"
                  class="white--text"
                  @click="deleteMulti"
                  v-else
                  disabled
                  >Delete Items ({{ selected.length }})</v-btn
                >
              </template>

              <template>
                <v-btn
                  small
                  color="teal darken-1"
                  class="white--text"
                  v-if="
                    status == 'Ready To Export' &&
                    selected.length > 0 &&
                    roles.convert_to_psl
                  "
                  @click="dialogConvert = !dialogConvert"
                  >Convert to PSL<v-icon right dark
                    >mdi-swap-horizontal-bold</v-icon
                  ></v-btn
                >
                <v-btn
                  small
                  color="teal darken-1"
                  class="white--text"
                  v-else
                  disabled
                  >Convert to PSL<v-icon right dark
                    >mdi-swap-horizontal-bold</v-icon
                  ></v-btn
                >
              </template>
            </v-speed-dial>

            <v-speed-dial
              v-model="fab"
              :direction="direction"
              :open-on-hover="false"
              :transition="transition"
              style="width: 15px; display: inline"
              v-else
            >
              <template v-slot:activator>
                <v-btn small v-model="fab" color="blue darken-2" dark disabled>
                  More Actions
                  <v-icon v-if="fab">mdi-close</v-icon>
                  <v-icon v-else>mdi-plus-circle</v-icon>
                </v-btn>
              </template>
            </v-speed-dial>
            &nbsp;
            <template v-if="selected.length > 0">
              <!-- {{selected.length}} item(s) selected &nbsp; -->
              <v-btn
                small
                color="blue-grey darken-3"
                class="white--text"
                @click="clearSelected"
                >Clear ({{ selected.length }})<v-icon right dark
                  >mdi-eraser</v-icon
                ></v-btn
              >
            </template>
            &nbsp;

            <template v-if="status == 'Ready To Export'">
              <v-btn
                small
                color="info"
                class="white--text"
                @click="dialogUpload = !dialogUpload"
                v-if="roles.allow_to_export"
                >Export<v-icon right dark>mdi-calendar-export</v-icon></v-btn
              >
              <v-btn small color="info" class="white--text" v-else disabled
                >Export<v-icon right dark>mdi-calendar-export</v-icon></v-btn
              >
            </template>
            &nbsp;

            <!-- &nbsp;<v-btn small  class="btn btn-primary btn-sm" @click="check"><i class="fa fa-plus-square"></i> Check</v-btn>&nbsp; -->
            <Import v-if="checkRoles('Administrator')" />
          </template>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" style="padding-bottom: 0px !important">
          <v-tabs v-model="tab">
            <v-tabs-slider color="teal lighten-3"></v-tabs-slider>

            <v-tab @click="searchStatus('')">
              <b>All</b>
              <v-chip x-small color="primary" dark>{{
                totalCrawlProducts.toString()
              }}</v-chip>
            </v-tab>

            <v-tab @click="searchStatus('Pending')">
              <b>Pending</b>

              <v-chip x-small color="orange" dark>{{
                pendingProducts.toString()
              }}</v-chip>
            </v-tab>

            <v-tab @click="searchStatus('Missing Info')">
              <b>Missing Info</b>
              <v-chip x-small color="deep-orange darken-4" dark>{{
                missingInfoProducts.toString()
              }}</v-chip>
            </v-tab>

            <v-tab @click="searchStatus('Ready To Export')">
              <b>Ready To Export</b>
              <v-chip x-small color="light-green" dark>{{
                readyToExportProducts.toString()
              }}</v-chip>
            </v-tab>
          </v-tabs>
        </v-col>
        <v-divider></v-divider>
        <v-col
          cols="12"
          style="
            padding-top: 0px !important;
            background-clip: content-box;
            background-color: white;
          "
        >
          <v-row>
            <v-col cols="3">
              <v-text-field
                label="Search here"
                outlined
                v-model="searchWord"
                @keyup.enter="search"
                v-if="searchBy != ''"
                dense
              ></v-text-field>
              <v-text-field
                label="Search here"
                outlined
                v-else
                disabled=""
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="8">
              <v-row>
                <v-select
                  :items="listSearchAll"
                  :item-text="(obj) => obj.value"
                  :item-value="(obj) => obj.id"
                  label="Search All"
                  dense
                  outlined
                  v-model="searchBy"
                ></v-select>

                <template v-if="status != 'Pending'">
                  <v-select
                    :items="listSites"
                    :item-text="(obj) => obj.showName"
                    :item-value="(obj) => obj.code"
                    label="Site"
                    dense
                    outlined
                    v-model="siteCode"
                  ></v-select>
                  <v-select
                    :items="listProductType"
                    :item-text="(obj) => obj.product_type"
                    :item-value="(obj) => obj._id"
                    label="Product Type"
                    dense
                    outlined
                    v-model="productTypeId"
                  ></v-select>
                </template>

                <template v-else>
                  <v-select label="Site" dense outlined disabled></v-select>
                  <v-select
                    label="Product Type"
                    dense
                    outlined
                    disabled
                  ></v-select>
                </template>

                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  persistent
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      label="Created Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dates"
                    range
                    scrollable
                  ></v-date-picker>
                  <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
                </v-menu>
              </v-row>
            </v-col>

            <v-col cols="1">
              <v-btn
                small
                @click.stop="drawer = !drawer"
                outlined
                color="indigo"
                >Filter Data</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>

    <v-alert
      v-if="alert == true"
      close-text="Close Alert"
      dense
      text
      type="success"
      dismissible
      style="text-align: left"
    >
      {{ informText }}
    </v-alert>

    <v-alert
      v-if="alert == false"
      close-text="Close Alert"
      dense
      text
      type="error"
      dismissible
      style="text-align: left"
    >
      {{ informText }}
    </v-alert>

    <v-col cols="12" style="margin-top: 0px">
      <!-- status == "Pending" -->
      <!-- <v-data-table
        v-model="selected"
        :headers="headers"
        :items="crawlProducts"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1"
        item-key="product_id"
        show-select
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100, 200, 500],
        }"
        v-if="status == 'Pending'"
      >
        <template v-slot:item.design_amount="{ item }">
          <v-menu
            :close-on-content-click="false"
            :nudge-width="200"
            offset-x
            persistent
            v-if="item.original_designs.length > 0"
          >
            <template v-slot:activator="{ on, attrs }">
              <a v-bind="attrs" v-on="on">
                {{ item.original_designs.length }}
              </a>
            </template>
            <v-card class="mx-auto status-scroll" max-width="344" outlined>
              <v-col
                cols="12"
                three-line
                v-for="(i, index) in item.original_designs"
                :key="index"
                class="border"
                style="text-align: left; font-size: 12px"
              >
                <template>
                  <div><b>Designer Username:</b> {{ i.designer_username }}</div>
                  <div>
                    <b>URL: </b>
                    <template v-if="i.design_url.indexOf('http') > -1">
                      <a :href="i.design_url" target="_blank">Link</a>
                    </template>
                  </div>
                  <div><b>ID:</b> {{ i.design_id }}</div>
                  <div><b>Created Date:</b> {{ i.created_date }}</div>
                </template>
              </v-col>
            </v-card>
          </v-menu>
          <template v-else>0 Design</template>
        </template>
        <template v-slot:item.preview_imgs="{ item }">
          <img v-bind:src="item.thumbnail" style="width: 100px" />
        </template>
        <template v-slot:item.additional_info="{ item }">
          <td>
            <template v-for="(value, key) in item.additional_info">
              <template v-if="value.toString().indexOf('http') > -1">
                {{ key }}:
                <a :href="value" :key="'a' + key" target="_blank"
                  >product link</a
                >
                <br :key="key" />
              </template>
              <template v-else>
                {{ key }}: {{ value }} <br :key="key" />
              </template>
            </template>
          </td>
        </template>
        <template v-slot:item.title="{ item }">
          <b>Shopify Title: </b>
          <div>{{ item.title }}</div>
          <b>Amazon Title: </b>
          <div>{{ item.amazon_title }}</div>
          <b>Original Title: </b>
          <div>{{ item.original_title }}</div>
        </template>
        <template v-slot:item.title_edited_date="{ item }">
          <div>{{ item.title_edited_username }}</div>
          <div>{{ item.title_edited_date }}</div>
        </template>
        <template v-slot:item.created_user="{ item }">
          <div>{{ item.created_user }}</div>
          <div>{{ item.created_date }}</div>
        </template>
        <template v-slot:item.published_sites="{ item }">
          <td style="font-size: 12px">
            <div v-for="(i, index) in item.marketing_code" :key="index">
              {{ i[0] }}-<b>{{ i[1] }}</b>
            </div>
          </td>
        </template>

        <template v-slot:item.scaled_user="{ item }">
          <div>{{ item.last_scaled_user }}</div>
          <div>{{ item.last_scaled_date }}</div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="orange"
            x-small
            dark
            @click="deleteItem(item)"
            v-if="roles.delete_crawled_product"
          >
            <v-icon small> mdi-delete </v-icon>
          </v-btn>
        </template>
      </v-data-table> -->

      <!-- status == "Ready To Export" -->

      <v-data-table
        v-model="selected"
        :headers="headers2"
        :items="crawlProducts"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1"
        item-key="product_id"
        show-select
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100, 200, 500],
        }"
        v-if="status == 'Ready To Export'"
      >
        <template v-slot:item.title="props">
          <b>Shopify Title: </b>

          <div>{{ props.item.title }}</div>

          <b>Amazon Title: </b>
          <div>{{ props.item.amazon_title }}</div>
          <b>Original Title: </b>
          <div>{{ props.item.original_title }}</div>
        </template>
        <!-- <template v-slot:item.tags_name="{ item }">
          <v-autocomplete
            style="width: 100%"
            v-model="item.tags"
            :items="listTags"
            :item-text="(obj) => obj.tag_name"
            :item-value="(obj) => obj._id"
            outlined
            dense
            chips
            small-chips
            label="Select Tag"
            multiple
            small
            clearable
            @input="searchData = null"
            @change="showBtnSaveTag(item)"
          ></v-autocomplete>
          <v-btn
            medium
            color="success"
            @click="assignTag(item)"
            v-if="item.showBtn && !loadingTag && roles.edit_title"
            >Save Tag</v-btn
          >
          <v-btn medium v-else-if="item.showBtn && loadingTag" disabled
            >Save Tag</v-btn
          >
        </template> -->
        <template v-slot:item.title_edited_date="{ item }">
          <div>{{ item.title_edited_username }}</div>
          <div>{{ item.title_edited_date }}</div>
        </template>
        <template v-slot:item.design_amount="{ item }">
          <v-menu
            :close-on-content-click="false"
            :nudge-width="200"
            offset-x
            persistent
            v-if="
              item.original_designs.length > 0 && roles.read_crawled_product
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <a v-bind="attrs" v-on="on">
                {{ item.original_designs.length }} Design(s)
              </a>
            </template>
            <v-card class="mx-auto status-scroll" max-width="344" outlined>
              <v-col
                cols="12"
                three-line
                v-for="(i, index) in item.original_designs"
                :key="index"
                class="border"
                style="text-align: left; font-size: 12px"
              >
                <!-- <template v-if="index == item.order_statuses.length-1"> -->
                <template>
                  <div><b>Designer Username:</b> {{ i.designer_username }}</div>
                  <div>
                    <b>URL: </b
                    ><template v-if="i.design_url.indexOf('http') > -1">
                      <a :href="i.design_url" target="_blank">Link</a>
                    </template>
                  </div>
                  <div><b>ID:</b> {{ i.design_id }}</div>
                  <div><b>Created Date:</b> {{ i.created_date }}</div>
                </template>
              </v-col>
            </v-card>
          </v-menu>
          <template v-else>0 Design</template>
        </template>
        <template v-slot:item.preview_imgs="{ item }">
          <img v-bind:src="item.thumbnail" style="width: 100px" />
        </template>
        <template v-slot:item.scaled_user="{ item }">
          <div>{{ item.last_scaled_user }}</div>
          <div>{{ item.last_scaled_date }}</div>
        </template>
        <template v-slot:item.published_sites="{ item }">
          <td style="font-size: 12px" v-if="roles.read_crawled_product">
            <div v-for="(i, index) in item.marketing_code" :key="index">
              {{ i[0] }}-<b>{{ i[1] }}</b>
            </div>
          </td>
        </template>
        <template v-slot:item.created_user="{ item }">
          <div>{{ item.created_user }}</div>
          <div>{{ item.created_date }}</div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            x-small
            color="purple"
            dark
            @click="openDialogEditTitle(item)"
            v-if="roles.edit_title"
            ><v-icon small>mdi-circle-edit-outline</v-icon></v-btn
          >
          &nbsp;
          <v-btn
            x-small
            color="green"
            dark
            @click="scaleItem(item.product_id)"
            v-if="roles.scale_product"
            title="Scale New Product"
          >
            <v-icon small>mdi-content-duplicate</v-icon>
          </v-btn>
          &nbsp;
          <v-btn
            color="primary"
            x-small
            @click="editItem(item.product_id)"
            v-if="roles.read_crawled_product"
          >
            <v-icon small> mdi-pencil </v-icon>
          </v-btn>
          &nbsp;
          <v-btn
            color="orange"
            x-small
            dark
            @click="deleteItem(item)"
            v-if="roles.delete_crawled_product"
          >
            <v-icon small> mdi-delete </v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <!-- status == "Missing Info || Pending" -->
      <template v-if="status == 'Missing Info' || status == 'Pending'">
        <template v-if="!loading"
          ><v-col cols="12">
            <v-row>
              <v-col cols="2">
                <v-select
                  :items="[10, 20, 50, 100, 200, 500]"
                  dense
                  outlined
                  label="Items Per Page"
                  v-model="pagination.itemsPerPage"
                ></v-select>
              </v-col>
              <v-col cols="2" style="margin-top: 10px">
                {{ totalItems }} item(s)
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="2" style="margin-top: 10px">
                <v-checkbox
                  class="pa-0 ma-0"
                  @change="selectedAll"
                  v-model="selectedAllCheck"
                  label="Select All"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="2" style="margin-top: 5px">
                <v-btn
                  small
                  v-if="pagination.page > 1"
                  @click="pagination.page = pagination.page - 1"
                  ><v-icon small>mdi-arrow-collapse-left</v-icon></v-btn
                >
                <v-btn small v-else disabled
                  ><v-icon small>mdi-arrow-collapse-left</v-icon></v-btn
                >
                &nbsp;{{ pagination.page }}&nbsp;
                <v-btn small @click="pagination.page = pagination.page + 1"
                  ><v-icon small>mdi-arrow-collapse-right</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </v-col>

          <v-row>
            <v-col
              cols="3"
              v-for="(a, indexa) of crawlProducts"
              :key="indexa"
              class="border"
            >
              <v-row>
                <v-checkbox
                  v-model="a.selectedCheckbox"
                  @change="addToSelected(a)"
                  hide-details=""
                  class="ma-0 pa-0"
                ></v-checkbox>
              </v-row>
              <div><v-img :src="a.thumbnail" width="450px" /></div>

              <v-col cols="12">
                <template v-if="status == 'Missing Info'">
                  <v-btn
                    x-small
                    color="purple"
                    dark
                    @click="openDialogEditTitle(a)"
                    v-if="roles.edit_title"
                    >Edit Title</v-btn
                  >
                  &nbsp;
                  <v-btn
                    color="primary"
                    x-small
                    @click="editItem(a.product_id)"
                    v-if="roles.read_crawled_product"
                  >
                    Edit
                  </v-btn>
                </template>
                &nbsp;
                <a
                  :href="a.thumbnail.replace('-resized', '')"
                  target="_blank"
                  style="text-decoration: none"
                  ><v-btn color="cyan" dark x-small>PREVIEW</v-btn></a
                >
                &nbsp;

                <v-btn
                  color="orange"
                  x-small
                  dark
                  @click="deleteItem(a)"
                  v-if="roles.delete_crawled_product"
                >
                  Delete
                </v-btn>
              </v-col>

              <div style="text-align: left">
                <b>Shopify Title: </b>

                <div>{{ a.title }}</div>

                <b>Amazon Title: </b>
                <div>{{ a.amazon_title }}</div>
                <b>Original Title: </b>
                <div>{{ a.original_title }}</div>
                <div>
                  <b>Code: </b>
                  <div v-for="(i, index) in a.marketing_code" :key="index">
                    {{ i[0] }}-<b>{{ i[1] }}</b>
                  </div>
                </div>
                <div><b>Tags: </b>{{ a.tags_name }}</div>
                <div>
                  <b>Crawled: </b
                  ><span>{{ a.created_user }}, {{ a.created_date }}</span>
                </div>
                <div>
                  <b>Product Type: </b><span>{{ a.product_type_name }}</span>
                </div>
                <div>
                  <tr>
                    <td><b style="margin-right: 5px">Addition Info: </b></td>
                    <td>
                      <div>
                        <template v-for="(value, key) in a.additional_info">
                          <template
                            v-if="value.toString().indexOf('http') > -1"
                          >
                            {{ key }}:
                            <a :href="value" :key="'a' + key" target="_blank"
                              >product link</a
                            >
                            <br :key="key" />
                          </template>
                          <template v-else>
                            {{ key }}: {{ value }} <br :key="key" />
                          </template>
                        </template>
                      </div>
                    </td>
                  </tr>
                </div>
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <img v-bind:src="require('../../assets/loading/loading.gif')" />
        </template>
      </template>

      <!-- status = "" -->
      <v-data-table
        :headers="headers"
        :items="crawlProducts"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100, 200, 500],
        }"
        v-if="status == ''"
      >
        <template v-slot:item.preview_imgs="{ item }">
          <img v-bind:src="item.thumbnail" style="width: 100px" />
        </template>
        <template v-slot:item.design_amount="{ item }">
          <v-menu
            :close-on-content-click="false"
            :nudge-width="200"
            offset-x
            persistent
            v-if="item.original_designs.length > 0"
          >
            <template v-slot:activator="{ on, attrs }">
              <a v-bind="attrs" v-on="on">
                <b>{{ item.original_designs.length }} Design(s)</b>
              </a>
            </template>
            <v-card class="mx-auto status-scroll" max-width="344" outlined>
              <v-col
                cols="12"
                three-line
                v-for="(i, index) in item.original_designs"
                :key="index"
                class="border"
                style="text-align: left; font-size: 12px"
              >
                <!-- <template v-if="index == item.order_statuses.length-1"> -->
                <template>
                  <div><b>Designer Username:</b> {{ i.designer_username }}</div>
                  <div>
                    <b>URL: </b>
                    <template v-if="i.design_url.indexOf('http') > -1">
                      <a :href="i.design_url" target="_blank">Link</a>
                    </template>
                  </div>
                  <div><b>ID:</b> {{ i.design_id }}</div>
                  <div><b>Created Date:</b> {{ i.created_date }}</div>
                </template>
              </v-col>
            </v-card>
          </v-menu>
          <template v-else>0 Design</template>
        </template>

        <template v-slot:item.scaled_user="{ item }">
          <div>{{ item.last_scaled_user }}</div>
          <div>{{ item.last_scaled_date }}</div>
        </template>
        <template v-slot:item.title="{ item }">
          <b>Shopify Title: </b>
          <div>{{ item.title }}</div>
          <b>Amazon Title: </b>
          <div>{{ item.amazon_title }}</div>
          <b>Original Title: </b>
          <div>{{ item.original_title }}</div>
        </template>
        <template v-slot:item.title_edited_date="{ item }">
          <div>{{ item.title_edited_username }}</div>
          <div>{{ item.title_edited_date }}</div>
        </template>
        <template v-slot:item.created_user="{ item }">
          <div>{{ item.created_user }}</div>
          <div>{{ item.created_date }}</div>
        </template>
        <template v-slot:item.additional_info="{ item }">
          <td>
            <template v-for="(value, key) in item.additional_info">
              <template v-if="value.toString().indexOf('http') > -1">
                {{ key }}:
                <a :href="value" :key="'a' + key" target="_blank"
                  >product link</a
                >
                <br :key="key" />
              </template>
              <template v-else>
                {{ key }}: {{ value }} <br :key="key" />
              </template>
            </template>
          </td>
        </template>
        <template v-slot:item.published_sites="{ item }">
          <td style="font-size: 12px">
            <div v-for="(i, index) in item.marketing_code" :key="index">
              {{ i[0] }}-<b>{{ i[1] }}</b>
            </div>
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="primary"
            x-small
            @click="editItem(item.product_id)"
            v-if="item.status != 'Pending' && roles.read_crawled_product"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          &nbsp;
          <v-btn
            color="orange"
            x-small
            dark
            @click="deleteItem(item)"
            v-if="roles.delete_crawled_product"
          >
            <v-icon small> mdi-delete </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-col>

    <!-- <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snack = false"> Close </v-btn>
      </template>
    </v-snackbar> -->

    <!-- Filter -->
    <v-navigation-drawer v-model="drawer" absolute right temporary>
      <v-list nav dense class="menu-scroll">
        <v-list-item v-if="status != 'Pending'">
          <v-select
            :items="listSites"
            :item-text="(obj) => obj.showName"
            :item-value="(obj) => obj.code"
            label="Site"
            dense
            outlined
            v-model="siteCode"
          ></v-select>
        </v-list-item>

        <v-list-item v-if="status != 'Pending'">
          <v-select
            :items="listProductType"
            :item-text="(obj) => obj.product_type"
            :item-value="(obj) => obj._id"
            label="Product Type"
            dense
            outlined
            v-model="productTypeId"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listSearchAll"
            :item-text="(obj) => obj.value"
            :item-value="(obj) => obj.id"
            label="Search All"
            dense
            outlined
            v-model="searchBy"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-text-field
            label="Search here"
            outlined
            v-model="searchWord"
            @keyup.enter="search"
            v-if="searchBy != ''"
            dense
          ></v-text-field>
          <v-text-field
            label="Search here"
            outlined
            v-else
            disabled=""
            dense
          ></v-text-field>
        </v-list-item>

        <v-list-item>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            persistent
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                label="Created Date"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="dates" range scrollable></v-date-picker>
            <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
          </v-menu>
        </v-list-item>

        <v-list-item>
          <v-autocomplete
            :items="listNiches"
            label="Select Niches"
            dense
            multiple
            outlined
            v-model="nichesSelected"
            small-chips
            @input="searchInput2 = null"
            :search-input.sync="searchInput2"
          ></v-autocomplete>
        </v-list-item>

        <v-list-item v-if="status != 'Pending'">
          <v-autocomplete
            v-model="listTagsSelected"
            :items="listTags"
            :item-text="(obj) => obj.tag_name"
            :item-value="(obj) => obj._id"
            outlined
            dense
            chips
            small-chips
            label="Select Tags"
            multiple
            @input="searchInput = null"
            :search-input.sync="searchInput"
            item-disabled="disabled"
          >
          </v-autocomplete>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listCreatedCrawl"
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            label="Crawled By"
            dense
            outlined
            v-model="crawled_by"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-menu
            ref="menu4"
            v-model="menu4"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            persistent
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="scaleDateRangeText"
                label="Scale Date"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="scaleDates"
              range
              scrollable
            ></v-date-picker>
            <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
          </v-menu>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listCreatedCrawl"
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            label="Scale By"
            dense
            outlined
            v-model="scaled_by"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listEditor"
            label="Title Edited By"
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            dense
            outlined
            v-model="title_edited_by"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-menu
            ref="menu3"
            v-model="menu3"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            persistent
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="titleDateRangeText"
                label="Edited Title Date"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="titleDates"
              range
              scrollable
            ></v-date-picker>
            <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
          </v-menu>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listEditor"
            label="Title Edited By"
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            dense
            outlined
            v-model="title_edited_by"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-text-field
            label="Min Tittle Length"
            v-model="minTitleLength"
            dense
            outlined
          ></v-text-field>
        </v-list-item>

        <v-list-item>
          <v-radio-group v-model="title_edited" row label="Title Edited">
            <v-radio label="Yes" value="true"></v-radio>
            <v-radio label="No" value="false"></v-radio>
          </v-radio-group>
        </v-list-item>

        <v-list-item>
          <v-radio-group
            v-model="duplicated_original_title"
            row
            label="Duplicate Original Title"
          >
            <v-radio label="Yes" value="true"></v-radio>
            <v-radio label="No" value="false"></v-radio>
          </v-radio-group>
        </v-list-item>

        <v-col cols="12">
          <!-- <v-btn @click.stop="drawer = false"  color="warning" fab x-small dark style="float:left">
            <v-icon class="fa fa-arrow-left"></v-icon>
          </v-btn>&nbsp; -->
          <v-btn
            @click="search"
            small
            outlined
            color="indigo"
            style="float: left"
            >Apply</v-btn
          >
          <v-btn
            @click="reset"
            small
            outlined
            color="indigo"
            style="float: right"
            >Reset</v-btn
          >
        </v-col>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>


<script>
import axios from "axios";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";
//import Vue from "vue";
import moment from "moment-timezone";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "Sites",
  //new Vue({
  components: {},

  data: () => ({
    tab: null,
    items: ["web", "shopping", "videos", "images", "news"],

    listDesigner: [],
    listMarketer: [],
    listIdea: [],
    listUploader: [],
    listSite: [],
    listProductManager: [],

    roles: [],
    alert: null,
    dialogUpload: false,
    dialogTag: false,
    dialogAssignProductType: false,
    dialogConvert: false,
    dialogEditTitleTag: false,
    editTitleItem: null,
    loadingData: false,
    loading: true,
    drawer: false,
    group: null,
    loadingTag: false,

    searchBy: "",
    searchWord: "",
    productTypeId: "",
    listTags: [],
    listNiches: [],
    nichesSelected: [],
    status: "",
    created_from: "",
    created_to: "",
    dates: [],
    titleDates: [],
    scaleDates: [],
    textDates: "",
    siteCode: "",
    searchInput: null,
    searchInput2: null,
    searchData: null,
    crawled_by: "",
    scaled_by: "",
    title_edited: null,
    snackColor: "",
    snackText: "",
    snack: false,
    title_edited_by: "",
    max200chars: (v) => v.length <= 200 || "Maximum 200 characters!",
    duplicated_original_title: null,
    minTitleLength: "",

    direction: "bottom",
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    transition: "slide-y-reverse-transition",

    filterData: {
      searchBy: "",
      searchWord: "",
      productTypeId: "",
      listTagsSelected: [],
      dates: [],
      productTypeName: "",
      status: "",
      niches: [],
    },

    totalItems: 0,
    pendingProducts: 0,
    missingInfoProducts: 0,
    readyToExportProducts: 0,
    totalCrawlProducts: 0,
    crawlProducts: [],

    pagination: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      groupBy: false,
      groupDesc: false,
      multiSort: false,
      mustSort: false,
    },

    selected: [],
    userId: "",
    menu2: false,
    menu3: false,
    menu4: false,
    informText: "",
    userEmail: "",

    listProductType: [],
    listTagsSelected: [],
    listSites: [],
    listEditor: [],
    listTagsStr: "",

    AuthStr: "", //'Bearer '.concat(this.$cookies.get('token')),
    headers: [
      { text: "Image", align: "start", value: "preview_imgs", sortable: false },
      { text: "Title", value: "title", width: "300px" },
      { text: "Status", value: "status" },
      { text: "Published Sites", value: "published_sites" },
      { text: "Info", value: "additional_info" },
      { text: "Tags", value: "tags_name", width: "250px" },
      { text: "Product Type", value: "product_type_name" },
      { text: "Crawled By", value: "created_user" },
      { text: "Scaled By", value: "scaled_user" },
      { text: "Title Edited Date", value: "title_edited_date" },
      { text: "PTS Design", value: "design_amount" },
      { text: "Total Sales", value: "total_sales" },
      { text: "Total Orders", value: "total_orders" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    headers2: [
      { text: "Image", align: "start", value: "preview_imgs", sortable: false },
      { text: "Title", value: "title", width: "300px" },
      { text: "Status", value: "status" },
      { text: "Published Sites", value: "published_sites" },
      { text: "Tags", value: "tags_name", width: "250px" },
      { text: "Product Type", value: "product_type_name" },
      { text: "Crawled By", value: "created_user" },
      { text: "Scaled By", value: "scaled_user" },
      { text: "Title Edited Date", value: "title_edited_date" },
      { text: "PTS Design", value: "design_amount" },
      { text: "Total Sales", value: "total_sales" },
      { text: "Total Orders", value: "total_orders" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    listCreatedCrawl: [],
    listSearchAll: [
      { id: "title", value: "Title" },
      { id: "original_title", value: "Original Title" },
      { id: "product_id", value: "Product ID" },
    ],
    selectedItem: [],
    selectedAllCheck: false,
  }),

  watch: {
    tab() {
      console.log("tab: ", this.tab);
    },
    listTagsSelected() {
      this.searchInput = null;

      var index = this.listTagsSelected.indexOf("null");

      if (index > -1) {
        for (var j of this.listTags) {
          if (j._id != "null") {
            j["disabled"] = true;
          }
        }
        //this.listTagsSelected = ["null"];
      } else {
        for (var k of this.listTags) {
          k["disabled"] = false;
        }
      }
    },

    nichesSelected() {
      this.searchInput2 = null;
    },

    pagination: {
      handler() {
        let queryParams = this.getParams();
        this.$router
          .push({ path: "test-new-feature", query: queryParams })
          .catch((err) => {
            var error = err.toString();
            if (!error.includes("redundant navigation")) {
              throw err;
            }
          });
        console.log("pagination");
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {
    this.$root.$refs.product = this;
  },

  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    titleDateRangeText() {
      return this.titleDates.join(" ~ ");
    },
    scaleDateRangeText() {
      return this.scaleDates.join(" ~ ");
    },
  },

  methods: {
    //GRID VIEW
    checkSelected() {
      for (var a of this.selected) {
        for (var b of this.crawlProducts) {
          if (a.product_id == b.product_id) {
            b.selectedCheckbox = true;
          }
        }
      }
    },

    addToSelected(item) {
      if (item.selectedCheckbox) {
        this.selected.push(item);
      } else {
        this.selected.splice(this.selected.indexOf(item), 1);
      }
    },

    selectedAll() {
      console.log("Click: ", this.selectedAllCheck);
      if (this.selectedAllCheck) {
        console.log("Click2");
        this.selected = [];
        for (var i of this.crawlProducts) {
          i.selectedCheckbox = true;
          this.selected.push(i);
        }
      } else {
        this.selected = [];
        for (var j of this.crawlProducts) {
          j.selectedCheckbox = false;
        }
      }
    },

    //Dialog
    turnOffDialog() {
      this.dialogTag = false;
      this.dialogUpload = false;
      this.dialogAssignProductType = false;
      this.dialogConvert = false;
      this.dialogEditTitleTag = false;
      this.selected = [];

      this.getDataFromApi();
    },

    async openDialogEditTitle(item) {
      this.selectedItem = item;
      this.editTitleItem = {
        title: item.title,
        amazon_title: item.amazon_title,
        tags: item.tags,
        product_id: item.product_id,
        original_title: item.original_title,
      };
      this.dialogEditTitleTag = true;
    },

    closeDialogEditTitle() {
      var tempTag = [];
      for (const z of this.editTitleItem.tags) {
        for (const x of this.listTags) {
          if (z == x._id) {
            tempTag.push(x.tag_name);
          }
        }
      }
      this.editTitleItem.tags_name = tempTag.join(", ");
      this.selectedItem.title = this.editTitleItem.title;
      this.selectedItem.tags = this.editTitleItem.tags;
      this.selectedItem.tags_name = tempTag.join(", ");
      this.dialogEditTitleTag = false;
    },

    //Action

    clearSelected() {
      this.selected = [];
      for (var j of this.crawlProducts) {
        j.selectedCheckbox = false;
      }
    },

    async changeStatus() {
      var list = [];
      this.selected.forEach((element) => {
        list.push(element.product_id);
      });

      var currentSession = await this.$root.$refs.App.currentSession(
        "crawl-product-changeStatus"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        fetch(window.domain + "test-new-feature/change-status", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify({
            new_status: "Missing Info",
            product_ids: list,
          }),
        })
          .then((response) => {
            console.log("changeStatus: ", response);
            this.getDataFromApi();
          })
          .catch((error) => console.log("Err: ", error));
        list = [];
        this.selected = [];
      } else {
        console.log(
          "currentSession crawl-product-changeStatus-undefined: ",
          currentSession
        );
      }
    },

    async addNewProduct() {
      const params = window.location.search;
      this.$router.push("/crawled-products-create" + params);
    },

    showAlert(type, data) {
      this.alert = true;
      if (type == "import") {
        this.informText =
          "We're currently importing your products into database. This could take about " +
          Math.floor(data / 100) +
          " minutes to complete. If you'd like, you can close this notification and continue to working.";
      } else {
        this.dialogUpload = false;
        this.informText =
          "Your export will be delivered by email to: " + this.userEmail;
      }
    },

    async loadData() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "CRL-convert-to-PSL loadData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        axios
          .get(window.domain + "personalize-products/get-data", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("response: ", response);
            this.listDesigner = response.data.data.designers;
            this.listMarketer = response.data.data.marketers;
            this.listIdea = response.data.data.ideas;
            this.listUploader = response.data.data.uploaders;
            this.listProductManager = response.data.data.product_managers;
            var emptyPerson = {
              _id: "",
              name: "",
              username: "",
            };

            this.listDesigner.unshift(emptyPerson);
            this.listIdea.unshift(emptyPerson);
            this.listMarketer.unshift(emptyPerson);
            this.listUploader.unshift(emptyPerson);
            this.listProductManager.unshift(emptyPerson);
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession CRL-convert-to-PSL loadData-undefined: ",
          currentSession
        );
      }
    },

    getParams() {
      this.informText = "";
      this.alert = null;

      let queryParams = {
        page: this.pagination.page,
        itemsPerPage: this.pagination.itemsPerPage,
        sortBy: this.pagination.sortBy[0],
        sortDesc: this.pagination.sortDesc[0],
      };

      if (this.searchBy != "" && this.searchWord != "") {
        queryParams["searchBy"] = this.searchBy;
        queryParams["searchWord"] = this.searchWord;
      }

      if (this.productTypeId != "") {
        queryParams["productTypeId"] = this.productTypeId;
      }

      if (this.status != "") {
        queryParams["status"] = this.status;
      }

      if (this.dates.length > 0) {
        if (this.dates[0] > this.dates[1]) {
          queryParams["created_from"] = this.dates[1];
          queryParams["created_to"] = this.dates[0];
        } else {
          queryParams["created_from"] = this.dates[0];
          queryParams["created_to"] = this.dates[1];
        }
      }

      if (this.listTagsSelected.length > 0) {
        this.listTagsStr = "";
        var index = this.listTagsSelected.indexOf("null");
        if (index < 0) {
          this.listTagsStr = this.listTagsSelected.join(",");
          queryParams["tagIds"] = this.listTagsStr;
        } else {
          queryParams["tagIds"] = "null";
        }
      }

      if (this.siteCode != "") {
        queryParams["siteCode"] = this.siteCode;
      }

      if (this.crawled_by != "") {
        queryParams["crawled_by"] = this.crawled_by;
      }

      if (this.title_edited != null) {
        queryParams["title_edited"] = this.title_edited;
      }

      if (this.title_edited_by != "") {
        queryParams["title_edited_by"] = this.title_edited_by;
      }

      if (this.minTitleLength != "") {
        queryParams["minTitleLength"] = this.minTitleLength;
      }

      if (this.titleDates.length > 0) {
        if (this.titleDates[0] > this.titleDates[1]) {
          queryParams["title_edited_from"] = this.titleDates[1];
          queryParams["title_edited_to"] = this.titleDates[0];
        } else {
          queryParams["title_edited_from"] = this.titleDates[0];
          queryParams["title_edited_to"] = this.titleDates[1];
        }
      }

      if (this.duplicated_original_title != null) {
        queryParams["duplicated_original_title"] =
          this.duplicated_original_title;
      }

      if (this.scaleDates.length > 0) {
        if (this.scaleDates[0] > this.scaleDates[1]) {
          queryParams["last_scaled_from"] = this.scaleDates[1];
          queryParams["last_scaled_to"] = this.scaleDates[0];
        } else {
          queryParams["last_scaled_from"] = this.scaleDates[0];
          queryParams["last_scaled_to"] = this.scaleDates[1];
        }
      }

      if (this.scaled_by != "") {
        queryParams["last_scaled_by"] = this.scaled_by;
      }

      if (this.nichesSelected.length > 0) {
        queryParams["niches"] = this.nichesSelected.join(",");
      }

      return queryParams;
    },

    async getDataFromApi() {
      this.loading = true;

      let queryParams = this.getParams();

      var currentSession = await this.$root.$refs.App.currentSession(
        "crawl-product-loadData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "products?", {
            headers: { Authorization: currentSession.accessToken },
            params: queryParams,
          })
          .then((response) => {
            // console.log(this.AuthStr)
            console.log("response: ", response);
            if (response.data.error_message == "") {
              this.crawlProducts = response.data.data.products;
              this.totalCrawlProducts = response.data.data.totalProducts || 0;

              this.pendingProducts = response.data.data.pendingProducts || 0;
              this.missingInfoProducts =
                response.data.data.missingInfoProducts || 0;
              this.readyToExportProducts =
                response.data.data.readyToExportProducts || 0;
              this.listProductType = response.data.data.product_types;
              this.listTags = response.data.data.tags;
              this.listNiches = response.data.data.niches;
              this.listSites = response.data.data.sites;
              this.listCreatedCrawl = response.data.data.crawlers;
              this.listEditor = response.data.data.title_editors;

              this.totalItems = response.data.data.marchingProducts || 0;
              //listTagsDisplay

              for (var i of this.listTags) {
                i["showName"] =
                  i.niche_classifier.join(" > ") + " > " + i.tag_name;
              }

              this.listTags.unshift({
                showName: "NO TAG",
                tag_name: "NO TAG",
                _id: "null",
              });

              if (this.listTagsSelected.length > 0) {
                var index = this.listTagsSelected.indexOf("null");

                if (index > -1) {
                  for (var j of this.listTags) {
                    if (j._id != "null") {
                      j["disabled"] = true;
                    }
                  }
                  //this.listTagsSelected = ["null"];
                } else {
                  for (var k of this.listTags) {
                    k["disabled"] = false;
                  }
                }
              }

              for (var site of this.listSites) {
                if (site.brand_name)
                  site["showName"] = site.code + "-" + site.brand_name;
                else site["showName"] = site.code;
              }

              if (this.crawlProducts.length > 0) {
                for (const i of this.listProductType) {
                  for (const j of this.crawlProducts) {
                    j["selectedCheckbox"] = false;
                    if (j.product_type_id == i._id) {
                      j["product_type_name"] = i.product_type;
                    }
                  }
                }

                for (const y of this.crawlProducts) {
                  y["tags_name"] = [];
                  y["marketing_code"] = [];
                  //y["checkTag"] = JSON.parse(JSON.stringify(y.tags));
                  //y["showBtn"] = false;
                  y.created_date = moment(y.created_date)
                    .tz("Asia/Ho_Chi_Minh")
                    .format("DD/MMM/YYYY - HH:mm");
                  if (y.title_edited_date) {
                    y.title_edited_date = moment(y.title_edited_date)
                      .tz("Asia/Ho_Chi_Minh")
                      .format("DD/MMM/YYYY - HH:mm");
                  }
                  if (y.last_scaled_date) {
                    y.last_scaled_date = moment(y.last_scaled_date)
                      .tz("Asia/Ho_Chi_Minh")
                      .format("DD/MMM/YYYY - HH:mm");
                  }

                  for (const w of y.published_sites) {
                    var temp = w.split("-");
                    y.marketing_code.push(temp);
                  }

                  for (const z of y.tags) {
                    for (const x of this.listTags) {
                      if (z == x._id) {
                        y.tags_name.push(x.tag_name);
                      }
                    }
                  }
                  y.tags_name = y.tags_name.join(", ");
                }
              }

              if (this.filterData.productTypeId != "") {
                var name = "";
                for (const i of this.listProductType) {
                  if (i._id == this.productTypeId) {
                    name = i.product_type;
                    break;
                  }
                }
                this.filterData.productTypeName = name;
              }
              this.checkSelected();
              console.log("filterData: ", this.filterData);
            } else {
              this.informText = response.data.error_message;
              this.alert = false;
            }
            this.loading = false;
          })
          .catch((error) => {
            console.log("Error:", error);
            this.loading = false;
            this.crawlProducts = [];
          });
      } else {
        console.log("crawl-product-getDataFromApi-undefined: ", currentSession);
      }
    },

    searchStatus(params) {
      this.selectedAllCheck = false;
      this.selected = [];
      this.$forceUpdate();

      if (params == "Pending") this.status = "Pending";
      else if (params == "Missing Info") this.status = "Missing Info";
      else if (params == "Ready To Export") this.status = "Ready To Export";
      else this.status = "";

      this.search();
    },

    search() {
      //this.selected = [];

      let queryParams = this.getParams();
      queryParams.page = 1;
      this.pagination.page = 1;

      var name = "";
      for (const i of this.listProductType) {
        if (i._id == this.productTypeId) {
          name = i.product_type;
          break;
        }
      }

      this.filterData = {
        searchBy: this.searchBy,
        searchWord: this.searchWord,
        productTypeId: this.productTypeId,
        productTypeName: name,
        listTagsSelected: this.listTagsSelected,
        dates: this.dates,
        status: this.status,
        niches: this.nichesSelected,
      };

      //console.log(this.filterData)

      this.$router
        .push({ path: "test-new-feature", query: queryParams })
        .catch((err) => {
          var str = err.toString();
          if (str.includes("current location")) {
            err = "";
          }
        });
      console.log("search");
      //console.log(this.dates)
      this.getDataFromApi();
    },

    reset() {
      //this.$router.push({ path: "products" });
      this.siteCode = "";
      this.searchWord = "";
      this.searchBy = "";

      if (this.checkRoles("Title Editor")) {
        this.status = "Missing Info";
      }
      // else {
      //   this.status = "";
      // }

      this.duplicated_original_title = null;
      this.title_edited = null;
      this.productTypeId = "";
      this.created_from = "";
      this.created_to = "";
      this.dates = [];
      this.minTitleLength = "";
      this.crawled_by = "";
      this.titleDates = [];
      this.title_edited_by = "";
      this.listTagsSelected = [];
      this.scaled_by = "";
      this.scaleDates = [];
      this.listTagsStr = "";
      this.nichesSelected = [];
      // (this.pagination = {
      //   page: 1,
      //   itemsPerPage: 10,
      //   sortBy: [],
      //   sortDesc: [],
      //   groupBy: false,
      //   groupDesc: false,
      //   multiSort: false,
      //   mustSort: false,
      // }),
      this.filterData = {
        searchBy: "",
        searchWord: "",
        productTypeId: "",
        productTypeName: "",
        listTagsSelected: [],
        dates: [],
        status: "",
        niches: [],
      };
      console.log("reset");
      //this.getDataFromApi();
    },

    editItem(item) {
      const params = window.location.search;
      this.$router.push("/product-detail/" + item + params);
    },

    scaleItem(item) {
      const params = window.location.search;
      this.$router.push("/scale-new-product/" + item + params);
    },

    async deleteItem(item) {
      const index = this.crawlProducts.indexOf(item);
      var r =
        confirm("Are you sure you want to delete this item?") &&
        this.crawlProducts.splice(index, 1);
      if (r != false) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "crawl-product-deleteItem"
        );
        //console.log('currentSession: ',currentSession.accessToken)
        if (currentSession.accessToken) {
          await axios
            .delete(window.domain + "products/" + item.product_id, {
              headers: { Authorization: currentSession.accessToken },
            })
            .then((response) => {
              console.log("delete Crawl response:", response);
            });
        } else {
          console.log("crawl-product-deleteItem", currentSession);
        }
      }
    },

    async deleteMulti() {
      var data = { product_ids: [] };
      //var indexItem = []
      for (const i of this.selected) {
        data.product_ids.push(i.product_id);
        //indexItem.push(this.crawlProducts.indexOf(i))
      }
      console.log(JSON.stringify(data));
      //console.log(indexItem)
      var r = confirm("Are you sure you want to delete these items?");
      if (r != false) {
        for (var t of data.product_ids) {
          for (var g = 0; g < this.crawlProducts.length; g++) {
            if (this.crawlProducts[g].product_id == t) {
              this.crawlProducts.splice(g, 1);
            }
          }
        }
        console.log(this.crawlProducts);

        var currentSession = await this.$root.$refs.App.currentSession(
          "crawl-product-deleteMulti"
        );

        if (currentSession.accessToken) {
          await fetch(window.domain + "products/delete-multi", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("delete Multi Crawl response:", data);
              this.selected = [];
            });
        } else {
          console.log("crawl-product-deleteMulti", currentSession);
        }
      }
    },

    async allowDataToExport() {
      var r = confirm("Are you sure to allow these products to export?");
      if (r != false) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "crawl-product-allowExport"
        );
        //console.log('currentSession: ',currentSession.accessToken)
        if (currentSession.accessToken) {
          var data = {
            new_status: "Ready To Export",
            product_ids: [],
          };

          for (const i of this.selected) {
            data.product_ids.push(i.product_id);
          }

          // console.log("data: ", data);

          await fetch(window.domain + "products/change-status", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("response change-status: ", data);
              this.selected = [];
              this.selectedAllCheck = false;
              this.getDataFromApi();
            })
            .catch((error) => console.log("Err: ", error));
        }
      }
    },

    async assignTag(itemData) {
      this.loadingTag = true;
      this.informText = "";
      this.alert = null;
      var item = {
        new_tag_ids: itemData.tags,
        product_ids: [itemData.product_id],
      };
      console.log(JSON.stringify(item));

      var currentSession = await this.$root.$refs.App.currentSession(
        "crawl-product-assign-tag"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await fetch(window.domain + "products/add-tags", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(item),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("assign-tag: ", data);
            if (data.error_message != "") {
              this.getDataFromApi();
              this.alert = false;
              if (
                data.error_message ==
                "new_tag_ids must be an array of product_id!"
              )
                this.informText = "At least 1 tag must be selected";
              else this.informText = data.error_message;
            } else if (data.error_message == "") {
              itemData.showBtn = false;
            }
          })
          .catch((error) => {
            console.log("Err: ", error);
          });
      } else {
        console.log(
          "currentSession crawl-product-assign-tag-undefined: ",
          currentSession
        );
      }

      this.crawlProducts.push("");
      this.crawlProducts.splice(this.crawlProducts.length - 1, 1);
      console.log(this.crawlProducts);
      this.loadingTag = false;
    },

    async removeTags() {
      var r = confirm(
        "Are you sure you want to remove tags from these products?"
      );
      if (r != false) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "crawl-product-removeTags"
        );
        //console.log('currentSession: ',currentSession.accessToken)
        if (currentSession.accessToken) {
          var selectedData = [];
          for (const i of this.selected) {
            selectedData.push(i.product_id);
          }

          fetch(window.domain + "products/remove-tags", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify({
              product_ids: selectedData,
            }), //JSON.stringify(this.editedItem)
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("removeTags response: ", data);
              if (data.error_message == "") {
                this.informText = "";
                var item = data.data;
                console.log(item);
                for (const i of item) {
                  for (const j of this.crawlProducts) {
                    if (i == j.product_id) {
                      j.tags = [];
                      j.tags_name = [];
                    }
                  }
                }
                var temp = [];
                this.crawlProducts.push(temp);
                this.crawlProducts.splice(this.crawlProducts.length - 1, 1);
                this.selected = [];
              } else {
                this.informText = data.error_message;
              }
            })
            .catch((error) => console.log("Err: ", error));
        } else {
          console.log("currentSession removeTags-undefined: ", currentSession);
        }
      }
    },

    check() {
      console.log("paginationdd: ", this.pagination);
      console.log("crawlProducts: ", this.crawlProducts);
      // console.log("dialogEditTitleTag: ", this.dialogEditTitleTag);
      // console.log("listTagsSelected: ", this.listTagsSelected);
      // console.log("listTags: ", this.listTags);
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },
  async mounted() {
    if (this.$route.query != "") {
      if (this.$route.query.page)
        this.pagination.page = parseInt(this.$route.query.page);
      if (this.$route.query.itemsPerPage)
        this.pagination.itemsPerPage = parseInt(this.$route.query.itemsPerPage);
      if (this.$route.query.sortBy)
        this.pagination.sortBy[0] = this.$route.query.sortBy;
      if (this.$route.query.sortDesc)
        this.pagination.sortDesc[0] = this.$route.query.sortDesc;

      if (this.$route.query.searchBy) {
        this.searchBy = this.$route.query.searchBy;
        this.filterData.searchBy = this.searchBy;
      }
      if (this.$route.query.searchWord) {
        this.searchWord = this.$route.query.searchWord;
        this.filterData.searchWord = this.searchWord;
      }

      if (this.$route.query.productTypeId) {
        this.productTypeId = this.$route.query.productTypeId;
        this.filterData.productTypeId = this.productTypeId;
      }

      if (this.checkRoles("Title Editor")) {
        console.log("Title Editor");
        this.status = "Missing Info";
      } else {
        if (this.$route.query.status) {
          this.status = this.$route.query.status;
        }
      }

      if (this.$route.query.crawled_by) {
        this.crawled_by = this.$route.query.crawled_by;
      }

      if (this.$route.query.niches) {
        this.nichesSelected = this.$route.query.niches.split(",");
        this.filterData.niches = this.$route.query.niches.split(",");
      }

      if (this.$route.query.created_from) {
        this.created_from = this.$route.query.created_from;
        this.dates.push(this.created_from);
      }
      if (this.$route.query.created_to) {
        this.created_to = this.$route.query.created_to;
        this.dates.push(this.created_to);
      }

      this.filterData.dates = this.dates;

      // if(this.dates.length > 0)
      // {this.dateRangeText = this.dates.join(' ~ ')}

      if (this.$route.query.tagIds) {
        this.listTagsStr = this.$route.query.tagIds;
        this.listTagsSelected = this.listTagsStr.split(",");
        this.filterData.listTagsSelected = this.listTagsSelected;
      }

      if (this.$route.query.siteCode)
        this.siteCode = this.$route.query.siteCode;

      if (this.$route.query.title_edited) {
        this.title_edited = this.$route.query.title_edited;
      }

      if (this.$route.query.title_edited_by) {
        this.title_edited_by = this.$route.query.title_edited_by;
      }

      if (this.$route.query.title_edited_from) {
        this.titleDates.push(this.title_edited_from);
      }

      if (this.$route.query.title_edited_to) {
        this.titleDates.push(this.title_edited_to);
      }

      if (this.$route.query.duplicated_original_title) {
        this.duplicated_original_title =
          this.$route.query.duplicated_original_title;
      }

      if (this.$route.query.last_scaled_by) {
        this.scaled_by = this.$route.query.last_scaled_by;
      }

      if (this.$route.query.last_scaled_from) {
        this.scaleDates.push(this.last_scaled_from);
      }

      if (this.$route.query.last_scaled_to) {
        this.scaleDates.push(this.last_scaled_to);
      }
    }

    this.roles = await this.$cookies.get("crawled_product");
    if (this.roles.list_crawled_products) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      console.log(this.roles);
      var currentSession;
      try {
        currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
        console.log("product-mounted currentSession: ", currentSession);
      } catch (error) {
        console.log("product-mounted error: ", error);
      }

      if (currentSession != undefined) {
        let username = currentSession.accessToken.payload.username;
        let accessToken = currentSession.accessToken.jwtToken;
        this.userId = username;

        console.log("accessToken-crawl-product: ", accessToken);
        await axios
          .get(window.domain + "users/" + username, {
            headers: { Authorization: accessToken },
          })
          .then((response) => {
            this.userEmail = response.data.data.email;
          })
          .catch((error) => {
            console.log("error ", error);
          });

        this.loadData();
      }
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.menu-scroll {
  height: 90vh;
  overflow: auto;
}
</style>